import classNames from 'classnames';
import { format } from 'date-fns';
import React from 'react';
import { MdInfo, MdWarning } from 'react-icons/md';
import { useSelector } from 'react-redux';
import { optimizationPricesResultSelector } from '../../../../../../../reducers/OtimizacaoPrecos';
import { useResult } from '../../../../hooks/useResult';
import { CardResult } from '../CardResult/CardResult';
import styles from './ResultGroup.module.scss';

export const ResultGroup = () => {
  const { isLoadingResult } = useResult();
  const { result } = useSelector(optimizationPricesResultSelector);
  const { category, stores, totalProducts, period, lastOptimization, nextOptimization, controlStore, createdAt } = result;
  const storesString = React.useMemo(() => {
    return stores.length > 1 ? stores?.map(item => item.storeId).join(', ') : stores?.map(item => item.storeName).join(', ');
  }, [stores]);

  const hasOptimization = !!lastOptimization;
  const nextOptimizationDate = nextOptimization ? format(new Date(nextOptimization), 'dd/MM/yyyy') : null;
  const showMessageOfLessControlStore = !isLoadingResult && !controlStore && hasOptimization;
  const showMessageOfLessOptimization = !isLoadingResult && !hasOptimization;

  return (
    <>
      {showMessageOfLessOptimization && (
        <div className={classNames(styles['tip-container'], styles.warning)}>
          <MdWarning />
          <p>
            O motor de otimização ainda não foi executado. A previsão de otimização de preços estará disponível a partir de terça-feira
            {nextOptimizationDate ? `, dia ${nextOptimizationDate}` : '.'}
          </p>
        </div>
      )}

      {showMessageOfLessControlStore && (
        <div className={classNames(styles['tip-container'], styles.info)}>
          <MdInfo />
          <span>Análise comparativa indisponível.</span>
          <p>Nenhuma loja controle foi selecionada, por isso não é possível realizar comparações de desempenho ao longo do tempo.</p>
        </div>
      )}
      <section className={styles.container}>
        <CardResult isLoading={isLoadingResult} label={`${category.level} - ${category?.name}`} content={category?.value} />
        <CardResult isLoading={isLoadingResult} label="Loja" content={storesString} />
        <CardResult isLoading={isLoadingResult} label="Total de produtos" content={totalProducts} />
        <CardResult isLoading={isLoadingResult} label="Frequência" content={period.label} />
        <CardResult isLoading={isLoadingResult} label="Criação" content={createdAt ? format(new Date(createdAt), 'dd/MM/yyyy') : null} />
        <CardResult
          isLoading={isLoadingResult}
          label="Última atualização"
          content={lastOptimization ? format(new Date(lastOptimization), 'dd/MM/yyyy') : null}
        />
      </section>
    </>
  );
};
